import { Navigate, useParams } from 'react-router-dom';

/** Legacy route — content lives on the information-desk page. */
export default function OrgAboutPage() {
  const { slug } = useParams<{ slug: string }>();
  return <Navigate to={`/org/${slug}/information-desk`} replace />;
}
